// MOD-07 — form yapı taşları. Değerler BE sabitlerini (FormType / FormFieldTypes /
// FormConstraints / FormSubmissionStatus) birebir aynalar; wire'da enum'lar string.

/** BE `FormType` — wire'da PascalCase string. */
export const FORM_TYPES = ['Contact', 'Quote', 'Career'] as const;
export type FormTypeValue = (typeof FORM_TYPES)[number];

/** BE `FormFieldTypes` — FieldsJson içinde küçük harf string. `file` yalnız Career'da izinli. */
export const FIELD_TYPES = [
  'text',
  'textarea',
  'email',
  'phone',
  'select',
  'checkbox',
  'date',
  'file',
] as const;
export type FieldType = (typeof FIELD_TYPES)[number];

/** BE `FormSubmissionStatus`. */
export const SUBMISSION_STATUSES = ['New', 'Read', 'Processed', 'Quarantined'] as const;
export type SubmissionStatus = (typeof SUBMISSION_STATUSES)[number];

/** İçerik moderatörünün ilerletebileceği durum akışı (Quarantined dışarıdan gelir, elle atanmaz). */
export const SUBMISSION_STATUS_FLOW = ['New', 'Read', 'Processed'] as const;

/** BE `FormConstraints` aynası — client-side ön doğrulama BE 400'lerini önler. */
export const FORM_CONSTRAINTS = {
  maxFields: 50,
  maxOptionsPerField: 100,
  maxKeyLength: 100,
  maxLabelLength: 300,
} as const;

/** BE `FormFieldTypes.RequiresOptions` — yalnız `select` seçenek listesi ister. */
export function fieldRequiresOptions(type: FieldType): boolean {
  return type === 'select';
}

/** Dışa aktarım biçimleri (BE `FormExportFormat`). */
export const EXPORT_FORMATS = ['xlsx', 'pdf'] as const;
export type ExportFormat = (typeof EXPORT_FORMATS)[number];
